import React, { useState, useEffect, useCallback } from 'react';
import apiService from '../api/apiService';
import './TablePages.css';

const Users: React.FC = () => {
  const [list, setList] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [cityFilter, setCityFilter] = useState('');
  const [citySuggestions, setCitySuggestions] = useState<string[]>([]);

  const load = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      if (cityFilter.trim()) params.set('city', cityFilter.trim());
      const url = params.toString() ? `/admin/users?${params.toString()}` : '/admin/users';
      const { data } = await apiService.get(url);
      setList(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    apiService.get('/admin/users/cities').then(({ data }) => setCitySuggestions(Array.isArray(data) ? data : [])).catch(() => {});
  }, []);

  const formatDate = (s: string) => (s ? new Date(s).toLocaleString() : '-');

  if (loading) return <p>Loading...</p>;

  return (
    <div className="table-page">
      <div className="table-toolbar">
        <div className="table-toolbar-filters">
          <label htmlFor="users-city-filter">City</label>
          <input
            id="users-city-filter"
            type="text"
            className="table-filter-input"
            placeholder="Filter by city..."
            value={cityFilter}
            onChange={(e) => setCityFilter(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && load()}
            list="users-city-suggestions"
          />
          <datalist id="users-city-suggestions">
            {citySuggestions.map((city) => (
              <option key={city} value={city} />
            ))}
          </datalist>
        </div>
        <div className="table-toolbar-right">
          <button type="button" onClick={load} className="btn-primary">Refresh</button>
        </div>
      </div>
      <div className="table-wrapper">
        <table className="data-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Mobile</th>
              <th>Email</th>
              <th>City</th>
              <th>Pincode</th>
              <th>Verified</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {list.map((row) => (
              <tr key={row.id}>
                <td>{row.full_name ?? '-'}</td>
                <td>{row.mobile_number}</td>
                <td>{row.email ?? '-'}</td>
                <td>{row.city ?? '-'}</td>
                <td>{row.pincode ?? '-'}</td>
                <td>{row.is_verified ? 'Yes' : 'No'}</td>
                <td>{formatDate(row.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Users;
